import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useBasketFlyoutOpenedState = (customKey?: string) => {
  const composedKey = `basket-flyout${customKey ?? ''};`;

  const {open, isOpen, cancel, hide, parameter} =
    useOpenedStateManager(composedKey);

  const openFlyout = (productId: number) => {
    open({parameter: `${productId}`});
  };

  return {
    open: openFlyout,
    close: cancel,
    hideFlyout: hide,
    isOpen,
    productId: parseInt(parameter || '0', 10),
  };
};
